import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import styles from "./SignUpApplyWrapper.module.scss"
import Button from "../../components/Button/Button"
import { Link } from "react-router-dom"
import Bg from "../../images/signUp/bg.jpg"
import { CircularProgress } from "@material-ui/core"

const SignUpApplyContainer = ({
  children,
  title,
  subtitle,
  onBack,
  onNext,
  isButtonSubmit,
  withBackBtn,
  className,
  isNextDisabled,
  isGoingBack,
  isSubmitting,
}) => {
  return (
    <div className={classNames(styles.signUpContainer, className)}>
      <div className={classNames("smallContainer", "fullWidth", styles.wrap)}>
        <h2 className={styles.mainTitle}>{title}</h2>
        <div className={styles.subtitleWrap}>
          <span className={classNames("text18m", styles.subtitle)}>
            {subtitle}
          </span>
        </div>
        {React.cloneElement(children, { isGoingBack })}
        <div
          className={classNames(styles.actionBtnsWrap, {
            [styles.withBackBtn]: withBackBtn,
          })}
        >
          {withBackBtn && (
            <Button
              buttonStyle="outlined"
              onClick={onBack}
              className={styles.backBtn}
            >
              Back
            </Button>
          )}
          <div className={styles.nextWrap}>
            <Button
              buttonStyle="contained"
              onClick={onNext}
              className={styles.nextBtn}
              disabled={isSubmitting}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {isSubmitting ? (
                <span style={{ display: "flex", alignItems: "center" }}>
                  <CircularProgress
                    size={16}
                    style={{ color: "white", marginRight: 8 }}
                  />
                  Submitting...
                </span>
              ) : (
                isButtonSubmit ? "Submit" : "Next"
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

SignUpApplyContainer.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onBack: PropTypes.func,
  onNext: PropTypes.func.isRequired,
  isButtonSubmit: PropTypes.bool,
  withBackBtn: PropTypes.bool,
  className: PropTypes.string,
  isNextDisabled: PropTypes.bool,
  isGoingBack: PropTypes.bool,
  isSubmitting: PropTypes.bool,
}

export default SignUpApplyContainer
